<template>
  <div id="detail" class="detail">
    <!-- 头部区域 -->
    <div class="header-section">
      <div class="header-bg">
        <img src="@/assets/rightsDetails/chronicDisease/ChronicDisseDetailsHead.jpg" alt="头部背景" class="header-bg-img">
        <div class="advantages-section">
          <!-- 优势一 -->
          <div class="advantage-item advantage-item-1">
            <div class="advantage-header">
              <div class="advantage-title">优势一: 慢病健康呵护,专属私人医生</div>
              <div class="advantage-content">
                <div class="advantage-text advantage-text-1">
                  私人医生先采集被保险人病史、生活习惯、身高体重等数据,建立专属健康档案与个性化健康管理方案。了解其当前病情及用药情况,简化用药流程、定期提醒,同时调整药品种类与剂量以避免滥用。医生还会分析日常健康监测异常数据,动态调整方案并给予指导,结合身体状况提供饮食、运动、心理等干预手段,从源头控风险、减并发症。
                </div>
              </div>
            </div>
          </div>

          <!-- 优势二 -->
          <div class="advantage-item advantage-item-2">
            <div class="advantage-header">
              <div class="advantage-title">优势二: 甄选全球医疗资源,全球救援无边界,医疗护航零距离</div>
              <div class="advantage-content">
                <div class="advantage-text advantage-text-2">
                  全球60万+服务网点，3200+双语"星使"提供本土化救援、治疗、协助、保护服务。救援服务覆盖全球无盲区，137个国家/地区、820个重点城市现场陪同。利用全球专业医疗资源，提供全流程海外就医服务。
                </div>
              </div>
            </div>
          </div>

          <!-- 优势三 -->
          <div class="advantage-item advantage-item-3">
            <div class="advantage-header">
              <div class="advantage-title">优势三: 数据预警早发现,您的随身智能健康管家</div>
              <div class="advantage-content">
                <div class="advantage-text advantage-text-3">
                  依托"大救星智能设备+大救星健康监测预警系统+大救星智能云平台"，提供健康监测、疾病趋势预报/突发疾病预警、在线医疗咨询、全球找药送药、全球医疗救援、医疗费用直付/垫付、院后康复、慢病管理等全方位服务，为被保人提供全生命周期健康管理。
                </div>
              </div>
            </div>
          </div>

          <!-- 优势四 -->
          <div class="advantage-item advantage-item-4">
            <div class="advantage-header">
              <div class="advantage-title">优势四: "一键救援",有求必应</div>
              <div class="advantage-content">
                <div class="advantage-text advantage-text-4">
                  健康预警与紧急救援无缝衔接。无论居家、市内、出差旅行，提供全程守护，提供紧急医疗转运、医疗送返、住院保证、医疗监护、绿色通道服务、安全管家服务、紧急联系、安全管家服务。
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- 服务权益说明部分 -->
        <div class="service-rights-section">
          <div class="service-rights-header">
            <!-- <img src="@/assets/rightsDetails/chronicDisease/fwqybtleft.png" alt="服务权益说明左侧" class="service-rights-bg-left"> -->
            <div class="service-rights-title">服务权益说明</div>
            <!-- <img src="@/assets/rightsDetails/chronicDisease/fwqybtr.png" alt="服务权益说明右侧" class="service-rights-bg-right"> -->
          </div>

          <div class="service-list">
            <!-- 健康动态监测及预警服务 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('health-monitoring') }">
              <div class="service-item-header" @click="toggleItem('health-monitoring')">
                <div class="service-item-title">健康动态监测及预警服务</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="expandedItems.includes('health-monitoring') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('health-monitoring')">
                <div class="service-item-text">
                  <div class="service-sub-item">
                    <div class="service-sub-title">
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtleft.png" alt="左侧装饰" class="service-sub-title-icon-left">
                      <span class="service-sub-title-text">24小时健康监测服务</span>
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtr.png" alt="右侧装饰" class="service-sub-title-icon-right">
                    </div>
                    <div class="service-sub-text">为被保险人提供智能监测手表、血压计、心电仪及使用说明书，被保险人正确佩戴，可提供24小时实时掌握包括心率、血氧饱和度、血压、体温、睡眠质量及日常运动步数等在内的多项健康指标，并提供心电监测服务。所有数据实时上传到大救星健康版App中，依托大救星AI算法模型计算身体健康分数，供被保险人随时掌握自身健康情况。（响应时效：7*24小时 权益次数：不限次）</div>
                  </div>
                  <div class="service-sub-item">
                    <div class="service-sub-title">
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtleft.png" alt="左侧装饰" class="service-sub-title-icon-left">
                      <span class="service-sub-title-text">24小时疾病趋势预报服务</span>
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtr.png" alt="右侧装饰" class="service-sub-title-icon-right">
                    </div>
                    <div class="service-sub-text">依托中国中医科学院科研成果--中医五藏态势监测技术及科学中医诊断，被保险人佩戴满24小时后显示"您有一份新的中医报告"，点击"查看报告"显示：心藏、肝藏、肾藏、脾藏评分结果并能查看其它体测数据。根据周期性身体指标趋势向被保险人提供调理或检查建议。（响应时效：7*24小时 权益次数：不限次）</div>
                  </div>
                  <div class="service-sub-item">
                    <div class="service-sub-title">
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtleft.png" alt="左侧装饰" class="service-sub-title-icon-left">
                      <span class="service-sub-title-text">24小时疾病及时预警服务</span>
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtr.png" alt="右侧装饰" class="service-sub-title-icon-right">
                    </div>
                    <div class="service-sub-text">被保险人通过佩戴这款智能监测手表、血压计及心电仪进行日常监测，实时掌握自己的生命体征。一旦突发健康数据异常，手表会及时发出提醒，提示被保险人关注异常信息并采取必要的处置措施。（响应时效：7*24小时 权益次数：不限次）</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 私人医生 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('private-doctor') }">
              <div class="service-item-header" @click="toggleItem('private-doctor')">
                <div class="service-item-title">私人医生</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="expandedItems.includes('private-doctor') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('private-doctor')">
                <div class="service-item-text">
                    为每位被保险人配置个人专属医生，医生均具有中国境内三级甲等医疗机构至少5年以上心血管专科从业经验，非常熟知各类心血管疾病的预防及治疗。系统全面提供精准评估、科学用药、监测数据异常分析解读、行为干预、教育赋能、团队协作及长期跟踪等管理手段，帮助控制病情，延缓并发症，提高生活质量。（响应时效：7*24小时 权益次数：不限次）
                </div>
              </div>
            </div>

            <!-- 名医直通车 -->
            <div class="service-item" :class="{ 'expanded': vipDoctorExpanded }">
              <div class="service-item-header" @click="toggleVipDoctor">
                <div class="service-item-title">名医直通车</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="vipDoctorExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
             <div class="service-item-content" v-show="vipDoctorExpanded">
                <div class="service-item-text">
                  <div class="service-sub-item">
                    <div class="service-sub-title">
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtleft.png" alt="左侧装饰" class="service-sub-title-icon-left">
                      <span class="service-sub-title-text">名医在线诊疗</span>
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtr.png" alt="右侧装饰" class="service-sub-title-icon-right">
                    </div>
                    <div class="service-sub-text">优选安贞医院心血管专科专家团队为被保险人提供预约制在线诊疗服务。（响应时效：3小时内 服务有效期：1-3天 权益次数：1次）</div>
                  </div>
                  <div class="service-sub-item">
                    <div class="service-sub-title">
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtleft.png" alt="左侧装饰" class="service-sub-title-icon-left">
                      <span class="service-sub-title-text">名医预约挂号</span>
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtr.png" alt="右侧装饰" class="service-sub-title-icon-right">
                    </div>
                    <div class="service-sub-text">为被保险人优选安贞医院心血管专科专家团队的门诊挂号服务。（响应时效：3小时内 服务有效期：3-5个工作日 权益次数：1次）</div>
                  </div>
                  <div class="service-sub-item">
                    <div class="service-sub-title">
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtleft.png" alt="左侧装饰" class="service-sub-title-icon-left">
                      <span class="service-sub-title-text">名医住院安排</span>
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtr.png" alt="右侧装饰" class="service-sub-title-icon-right">
                    </div>
                    <div class="service-sub-text">为被保险人安排安贞医院心血管专科专家团队的住院安排服务。（响应时效：3小时内 服务有效期：5-7个工作日 权益次数：1次）</div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 全球紧急救援 -->
            <div class="service-item" :class="{ 'expanded': globalRescueExpanded }">
              <div class="service-item-header" @click="toggleGlobalRescue">
                <div class="service-item-title">全球紧急救援</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="globalRescueExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="globalRescueExpanded">
                <div class="service-item-text">
                  <div class="service-sub-item">
                    <div class="service-sub-title">
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtleft.png" alt="左侧装饰" class="service-sub-title-icon-left">
                      <span class="service-sub-title-text">紧急医疗转运</span>
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtr.png" alt="右侧装饰" class="service-sub-title-icon-right">
                    </div>
                    <div class="service-sub-text">当被保险人在出行期间遭受意外伤害或突发疾病等情形，若经大救星的救援医生及主治医生共同确定，被保险人所在医院医疗设施无法满足病情需要，需要转运到上级医院进一步救治。在当地医院开具转院证明的情形下，大救星在适宜的医疗监督下，通过适当的转运方式将被保险人运送至最近的且能够提供必要医疗设施的医疗场所。大救星承担转运费用，最高费用总额以服务限额为限。（响应时效：5分钟内 服务有效期：2-3天 权益次数：不限次，限额20万元）</div>
                  </div>
                  <div class="service-sub-item">
                    <div class="service-sub-title">
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtleft.png" alt="左侧装饰" class="service-sub-title-icon-left">
                      <span class="service-sub-title-text">医疗送返</span>
                      <img src="@/assets/rightsDetails/chronicDisease/fwqybtr.png" alt="右侧装饰" class="service-sub-title-icon-right">
                    </div>
                    <div class="service-sub-text">当被保险人在出行期间遭受意外伤害或突发疾病等情形，在当地医院住院治疗一段时间，病情稳定或正常出院后，经大救星的救援医生及主治医生共同确认有医疗必要性需送返回到常住地的医疗机构或家中的情形下，大救星将安排适当的转运方式把被保险人送返回到常住地并承担转运费用，最高费用总额以服务限额为限。（响应时效：5分钟内 服务有效期：2-15天 权益次数：不限次，限额20万元）</div>
                  </div>
                
                </div>
              </div>
            </div>

            <!-- 住院协助 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('hospitalization-assist') }">
              <div class="service-item-header" @click="toggleItem('hospitalization-assist')">
                <div class="service-item-title">住院协助</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('hospitalization-assist') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('hospitalization-assist')">
                <div class="service-item-text">
                  被保险人由于心血管疾病需住院治疗时，在获得被保险人提供的住院单后，为其安排主诊医生或优选推荐医生的住院床位，并在就诊过程中，予以协助。（响应时效：8小时内 服务有效期：7-10个工作日 权益次数：1次）
                </div>
              </div>
            </div>

          

            <!-- 24小时在线医疗咨询服务 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('online-consultation') }">
              <div class="service-item-header" @click="toggleItem('online-consultation')">
                <div class="service-item-title">入院陪护</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('online-consultation') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('online-consultation')">
                <div class="service-item-text">
                    安排护理顾问协助被保险人现场办理入院手续，包括但不限于排队缴费、协助医患沟通等，当天护理顾问提早10分钟到达医院，提早熟悉现场环境，现场陪护时间不超过4小时。（响应时效：3小时内 服务有效期：2个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 二次诊疗 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('second-opinion') }">
              <div class="service-item-header" @click="toggleItem('second-opinion')">
                <div class="service-item-title">门诊协助</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('second-opinion') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('second-opinion')">
                <div class="service-item-text">
                    被保险人由于心血管疾病有门诊就医需求时，根据被保险人的原有诊断，精确分诊，协助被保险人选择合适的医院及专家就诊（可指定医院科室、不指定医生）并安排挂号服务。（响应时效：8小时内 服务有效期：3-7个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 多学科会诊 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('multidisciplinary-consultation') }">
              <div class="service-item-header" @click="toggleItem('multidisciplinary-consultation')">
                <div class="service-item-title">检查加急</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('multidisciplinary-consultation') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('multidisciplinary-consultation')">
                <div class="service-item-text">
                    由于心血管疾病引起的需要检查项目加急，可根据被保险人的需求，协调安排各项检查加急，包括B超、CT、MRI、MRA、PET-CT等，确保检查尽早进行。（响应时效：8小时内 服务有效期：3-7个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 海外就医安排 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('overseas-medical') }">
              <div class="service-item-header" @click="toggleItem('overseas-medical')">
                <div class="service-item-title">24小时在线医疗咨询服务</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="expandedItems.includes('overseas-medical') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('overseas-medical')">
                <div class="service-item-text">
                  为被保险人提供24小时在线医疗咨询服务，由三甲医院主治及以上全科及专科医生通过电话、视频或图文方式为被保险人提供一对一的心血管疾病专科咨询、日常医学咨询、诊前就医指导、慢性病管理咨询、预防及日常保健咨询等，由专业分诊人员根据问诊需求匹配医生、不可指定医生。在线咨询完毕后，根据实际需求享受线上购药及递送药品等全流程服务。药品及递送费用都由被保险人承担。（响应时效：15秒内/单次通话20分钟内 权益次数：7*24小时不限次）
                </div>
              </div>
            </div>

            <!-- 全球找药 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('global-drug-search') }">
              <div class="service-item-header" @click="toggleItem('global-drug-search')">
                <div class="service-item-title">二次诊疗</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('global-drug-search') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('global-drug-search')">
                <div class="service-item-text">
                  被保险人由于心血管疾病提出二次诊疗需求，协助被保险人收集各种必需的病情资料，由医学组全科医生根据被保险人的病情资料进行初审是否适用二诊（适用二诊情况：手术未定，多学科疾病，当前治疗方案下病情恶化等）。如初审通过后，3-7个工作日内将由工作人员代持被保险人相关病历资料向北上广TOP100三甲医院副主任及以上级别专家进行咨询，提供第二次专业医学意见书面报告，供被保险人及家属参考。（响应时效：8小时内 服务有效期：3-7个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 院后康复指导 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('rehabilitation-guidance') }">
              <div class="service-item-header" @click="toggleItem('rehabilitation-guidance')">
                <div class="service-item-title">多学科会诊</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('rehabilitation-guidance') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('rehabilitation-guidance')">
                <div class="service-item-text">
                    对于比较复杂的心血管重大疾病，如被保险人对疾病诊断有疑问时，可在7-10工作日内帮被保险人预约2-4个（含）科室多名权威专家（根据病情或被保险人要求确定）在非门诊时间进行视频面对面会诊。权威专家对被保险人的病情进行详细分析诊断，给出最适合的诊疗建议。（响应时效：8小时内 服务有效期：7-10个工作日 权益次数：1次）
                </div>
              </div>
            </div>

            <!-- 医后随访 -->
            <div class="service-item" :class="{ 'expanded': expandedItems.includes('medical-follow-up') }">
              <div class="service-item-header" @click="toggleItem('medical-follow-up')">
                <div class="service-item-title">海外就医安排</div>
                <div class="service-item-availability">1次</div>
                <img 
                  :src="expandedItems.includes('medical-follow-up') 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="expandedItems.includes('medical-follow-up')">
                <div class="service-item-text">
                    协助被保险人联系专业机构，7-14个工作日内由专业机构安排美国、德国、英国、日本海外顶级医院就诊，被保险人提供既往所有的病历资料，协助被保险人整理并传输病历资料，供专业机构安排海外就医诊疗。由此产生的第三方协调费用、签证费用、接送机费用、医疗费用、翻译费用等，需要被保险人承担。（响应时效：2个工作日 服务有效期：7-14个工作日 权益次数：1次）
                </div>
              </div>
            </div>
             <!-- 全球找药 -->
             <div class="service-item" :class="{ 'expanded': globalDrugSearchExpanded }">
              <div class="service-item-header" @click="toggleGlobalDrugSearch">
                <div class="service-item-title">全球找药</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="globalDrugSearchExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="globalDrugSearchExpanded">
                <div class="service-item-text">
                  如被保险人由于心血管疾病需申请全球找药服务，可持三甲级公立医疗机构开具7天内的国内已上市特药处方来申请服务，如国内特药无法满足治疗需求，经评估后可协调安排前往海南博鳌乐城国际医疗旅游先行区就诊，协助对接特药资源。大救星可提供资源推介、协调安排等服务，如因此产生药费、就诊费用、出行费用等，需由被保险人自行承担。（响应时效：8小时内 服务有效期：7-10个工作日 权益次数：不限次）
                </div>
              </div>
            </div>
             <!-- 院后康复指导 -->
             <div class="service-item" :class="{ 'expanded': rehabilitationGuidanceExpanded }">
              <div class="service-item-header" @click="toggleRehabilitationGuidance">
                <div class="service-item-title">院后康复指导</div>
                <div class="service-item-availability">不限次</div>
                <img 
                  :src="rehabilitationGuidanceExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="rehabilitationGuidanceExpanded">
                <div class="service-item-text">
                  由具有专业医学背景的医生与被保险人通过电话的方式进行一对一交流，提供康复指导，包括个人手术切口护理指导、锻炼方式及时长指导、饮食指导、术后心理康复指导等。（响应时效：1小时内/需提前4小时发起服务请求 权益次数：不限次）
                </div>
              </div>
            </div>
              <!-- 医后随访 -->
              <div class="service-item" :class="{ 'expanded': medicalFollowUpExpanded }">
              <div class="service-item-header" @click="toggleMedicalFollowUp">
                <div class="service-item-title">医后随访</div>
                <div class="service-item-availability">1-5次</div>
                <img 
                  :src="medicalFollowUpExpanded 
                    ? require('@/assets/rightsDetails/Daoan/uparrow.png')
                    : require('@/assets/rightsDetails/Daoan/downarrow.png')" 
                  alt="箭头" 
                  class="arrow-icon"
                >
              </div>
              <div class="service-item-content" v-show="medicalFollowUpExpanded">
                <div class="service-item-text">
                  经心血管专家诊治后，相关健康管理专员提供一年1-5次电话关爱随访服务。（响应时效：30秒内/单次通话15分钟内/4小时内安排 权益次数：1-5次）
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 下载引导图 -->
    <div v-if="showGuideImage" class="guide-image-overlay" @click="hideGuideImage">
      <div class="guide-image-content">
        <img src="@/assets/img/guide.png" alt="下载引导图" class="guide-image" />
      </div>
    </div>
    <!-- 固定定位的下载按钮 -->
    <div class="download-btn-wrapper">
      <button type="button" class="download-btn" @click="handleDownload">{{ downloadButtonText }}</button>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
/**
 * 泰和君安健康监测服务权益详情页面组件
 * 展示大救星"泰和君安"健康监测服务的权益说明
 */
export default {
  name: 'TaiheEquity',
  data() {
    return {
      /**
       * 展开的服务项列表
       * @type {Array<string>}
       */
      expandedItems: ['health-monitoring'], // 默认展开第一项
      /**
       * 名医直通车是否展开
       * @type {boolean}
       */
      vipDoctorExpanded: false, // 名医直通车默认收起
      /**
       * 全球紧急救援是否展开
       * @type {boolean}
       */
      globalRescueExpanded: false, // 全球紧急救援默认收起
      /**
       * 全球找药是否展开
       * @type {boolean}
       */
      globalDrugSearchExpanded: false, // 全球找药默认收起
      /**
       * 院后康复指导是否展开
       * @type {boolean}
       */
      rehabilitationGuidanceExpanded: false, // 院后康复指导默认收起
      /**
       * 医后随访是否展开
       * @type {boolean}
       */
      medicalFollowUpExpanded: false, // 医后随访默认收起
      /**
       * 是否显示下载引导图
       * @type {boolean}
       */
      showGuideImage: false,
      /**
       * 浏览器信息
       * @type {Object}
       */
      browser: null,
      /**
       * iOS下载链接
       * @type {string}
       */
      iosDownloadUrl: 'https://apps.apple.com/cn/app/%E5%A4%A7%E6%95%91%E6%98%9F%E5%81%A5%E5%BA%B7%E7%89%88/id6502325008'
    };
  },
  computed: {
    /**
     * 下载按钮文字
     * @returns {string}
     */
    downloadButtonText() {
      if (!this.browser) {
        return '下载大救星健康版App';
      }
      if (this.browser.versions.ios) {
        return '下载大救星健康版app';
      }
      return '下载大救星健康版App';
    }
  },
  mounted() {
    if (localStorage.getItem('oldAge') == 1) {
      document.getElementById('html').style.fontSize = '48px';
    }
    this.initBrowserInfo();
  },
  created() {
    document.title = '权益详情';
  },
  beforeCreate() {
    document
      .querySelector('#app')
      .setAttribute('style', 'background-color:#F2F3F5');
  },
  methods: {
    /**
     * 切换服务项的展开/折叠状态
     * @param {string} itemId - 服务项ID
     */
    toggleItem(itemId) {
      const index = this.expandedItems.indexOf(itemId);
      if (index > -1) {
        this.expandedItems.splice(index, 1);
      } else {
        this.expandedItems.push(itemId);
      }
    },
    /**
     * 切换名医直通车的展开/折叠状态
     */
    toggleVipDoctor() {
      this.vipDoctorExpanded = !this.vipDoctorExpanded;
    },
    /**
     * 切换全球紧急救援的展开/折叠状态
     */
    toggleGlobalRescue() {
      this.globalRescueExpanded = !this.globalRescueExpanded;
    },
    /**
     * 切换全球找药的展开/折叠状态
     */
    toggleGlobalDrugSearch() {
      this.globalDrugSearchExpanded = !this.globalDrugSearchExpanded;
    },
    /**
     * 切换院后康复指导的展开/折叠状态
     */
    toggleRehabilitationGuidance() {
      this.rehabilitationGuidanceExpanded = !this.rehabilitationGuidanceExpanded;
    },
    /**
     * 切换医后随访的展开/折叠状态
     */
    toggleMedicalFollowUp() {
      this.medicalFollowUpExpanded = !this.medicalFollowUpExpanded;
    },
    /**
     * 初始化浏览器信息
     */
    initBrowserInfo() {
      const u = navigator.userAgent;
      
      // 使用更准确的检测方法
      this.browser = {
        versions: {
          trident: u.indexOf('Trident') > -1, // IE内核
          presto: u.indexOf('Presto') > -1, // opera内核
          webKit: u.indexOf('AppleWebKit') > -1, // 苹果、谷歌内核
          gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1, // 火狐内核
          mobile: /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(u), // 是否为移动终端
          /** 微信内置 WebView（安卓内需引导用系统浏览器打开后才能下载 APK） */
          wechat: /MicroMessenger/i.test(u),
          // iOS设备检测：更准确的方法
          ios: /(iPhone|iPad|iPod|iOS)/i.test(u),
          // Android设备检测：只检测Android，不包括Linux
          android: /Android/i.test(u),
          // iPhone检测：只检测iPhone，不包括Mac
          iPhone: /iPhone/i.test(u),
          // iPad检测
          iPad: /iPad/i.test(u),
          // iPod检测
          iPod: /iPod/i.test(u),
          webApp: u.indexOf('Safari') == -1 // 是否web应该程序，没有头部与底部
        },
        language: (navigator.browserLanguage || navigator.language).toLowerCase()
      };
    },
    /**
     * 隐藏下载引导图
     */
    hideGuideImage() {
      this.showGuideImage = false;
    },
    /**
     * 获取 App 包下载接口基础地址
     * @returns {string}
     */
    getDownloadApiBase() {
      return window.SEVSRS || (!location.hostname || location.hostname.includes('test')
        ? 'http://health.dajiuxing.com.cn/health/api'
        : 'http://health.dajiuxing.com.cn/health/api');
    },
    /**
     * 请求后端获取 App 下载直链
     * @returns {Promise<string>}
     */
    fetchAppDownloadUrl() {
      const apiUrl = this.getDownloadApiBase();
      return axios({
        url: apiUrl + '/files/v1/app/download-url',
        method: 'get'
      }).then((response) => {
        const data = response.data || response;
        if (data.code == 1000 || data.code === '1000') {
          if (data.data && typeof data.data === 'string') {
            return data.data;
          }
          return Promise.reject(new Error('未获取到有效下载地址'));
        }
        return Promise.reject(new Error(data.msg || '获取下载链接失败'));
      });
    },
    /**
     * 延迟跳转地址，减少与当前渲染周期冲突
     * @param {string} url - 跳转 URL
     */
    navigateToDownloadUrl(url) {
      if (!url || typeof url !== 'string') {
        return;
      }
      window.setTimeout(() => {
        window.location.href = url;
      }, 0);
    },
    /**
     * 处理下载按钮点击
     */
    handleDownload() {
      if (!this.browser) {
        this.initBrowserInfo();
      }

      // iOS：跳转 App Store
      if (this.browser.versions.ios) {
        this.navigateToDownloadUrl(this.iosDownloadUrl);
        return;
      }

      // 安卓：仅微信内置浏览器需要「引导用浏览器打开」；已在外置浏览器中则直接拉取下载链
      if (this.browser.versions.android) {
        if (this.browser.versions.wechat) {
          this.showGuideImage = true;
        } else {
          this.fetchAppDownloadUrl()
            .then((url) => {
              this.navigateToDownloadUrl(url);
            })
            .catch((err) => {
              console.error('下载失败:', err);
              const msg = (err && err.message) ? err.message : '下载失败，请稍后重试';
              if (this.$toast) {
                this.$toast(msg);
              }
            });
        }
        return;
      }

      // 其他环境
      this.fetchAppDownloadUrl()
        .then((url) => {
          this.navigateToDownloadUrl(url);
        })
        .catch((err) => {
          console.error('下载失败:', err);
          const msg = (err && err.message) ? err.message : '下载失败，请稍后重试';
          if (this.$toast) {
            this.$toast(msg);
          }
        });
    }
  }
};
</script>

<style scoped>
.detail {
  width: 100%;
  height: auto;
  background-color: #FFC991;
  overflow-x: hidden;
  padding-bottom: 70px; /* 为固定定位的下载按钮留出空间 */
}

/* 头部区域 */
.header-section {
  width: 100%;
  position: relative;
}

.header-bg {
  width: 100%;
  position: relative;
}

.header-bg-img {
  width: 100%;
  display: block;
  position: relative;
  z-index: 1;
}

/* 优势部分 */
.advantages-section {
  width: 100%;
  padding: 13px 10px 0px 13px;
  position: relative;
  z-index: 2;
}

.advantage-item {
  width: 100%;
  margin-bottom: 13px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background-color: transparent;
}

/* .advantage-item-1 {
  background-image: url('~@/assets/rightsDetails/chronicDisease/Chronicdiseaseadvantageone.png');
}

.advantage-item-2 {
  background-image: url('~@/assets/rightsDetails/chronicDisease/Chronicdiseaseadvantageone2.png');
}

.advantage-item-3 {
  background-image: url('~@/assets/rightsDetails/chronicDisease/Chronicdiseaseadvantageone3.png');
}

.advantage-item-4 {
  background-image: url('~@/assets/rightsDetails/chronicDisease/Chronicdiseaseadvantageone.png');
} */

.advantage-header {
  width: 100%;
  position: relative;
  overflow: hidden;
  border-radius: 6px;
}

.advantage-title {
  position: relative;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  text-align: center;
  padding: 5px 30px;
  padding-bottom: 0;
  margin: 0;
  z-index: 1;
  border-radius: 22px 22px 0 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  box-sizing: border-box;
  line-height: 1.2;
  /* CSS 渐变背景替代图片 - 从上到下渐变 */
  background: linear-gradient(to bottom, #FDB02A 0%, #FF6A18 100%);
  box-shadow: 0 2px 8px rgba(255, 106, 24, 0.3);
  /* 添加装饰性边框效果 */
  border-bottom: 2px solid rgba(255, 255, 255, 0.2);
  width: 85%;
  margin: 0 auto;
}

/**
 * 优势一标题样式
 * 使用 CSS 渐变背景，高度 54px
 */
.advantage-item-1 .advantage-title {
  height: 54px;
  background: linear-gradient(to bottom, #FDB02A 0%, #FF6A18 100%);
  box-shadow: 0 2px 8px rgba(255, 106, 24, 0.3);
}

/**
 * 优势二标题样式
 * 使用 CSS 渐变背景，高度 84px（两行文字）
 */
.advantage-item-2 .advantage-title {
  height: 84px;
  background: linear-gradient(to bottom, #FDB02A 0%, #FF6A18 100%);
  box-shadow: 0 2px 8px rgba(255, 106, 24, 0.3);
  padding: 10px 30px;
  line-height: 1.4;
}

/**
 * 优势三标题样式
 * 使用 CSS 渐变背景，高度 84px（两行文字）
 */
.advantage-item-3 .advantage-title {
  height: 84px;
  background: linear-gradient(to bottom, #FDB02A 0%, #FF6A18 100%);
  box-shadow: 0 2px 8px rgba(255, 106, 24, 0.3);
  padding: 10px 30px;
  line-height: 1.4;
}

/**
 * 优势四标题样式
 * 使用 CSS 渐变背景，高度 54px
 */
.advantage-item-4 .advantage-title {
  height: 54px;
  background: linear-gradient(to bottom, #FDB02A 0%, #FF6A18 100%);
  box-shadow: 0 2px 8px rgba(255, 106, 24, 0.3);
}

.advantage-content {
  /* background-color: #fff; */
  padding: 10px 13px 16px;
  margin: 0;
  margin-top: 0;
  border-radius: 0 0 6px 6px;
  position: relative;
  z-index: 1;
  /* 背景图从上到下整个盒子展示 */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
  display: block;
  width: 100%;
  box-sizing: border-box;
}

.advantage-item-1 .advantage-content {
  background-image: url('~@/assets/rightsDetails/chronicDisease/Chronicdiseaseadvantageone.png');
  /* 背景图从上到下整个盒子展示 */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
}

.advantage-item-2 .advantage-content {
  background-image: url('~@/assets/rightsDetails/chronicDisease/Chronicdiseaseadvantageone.png');
  /* 背景图从上到下整个盒子展示 */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
}

.advantage-item-3 .advantage-content {
  background-image: url('~@/assets/rightsDetails/chronicDisease/Chronicdiseaseadvantageone.png');
  /* 背景图从上到下整个盒子展示 */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
}

.advantage-item-4 .advantage-content {
  background-image: url('~@/assets/rightsDetails/chronicDisease/Chronicdiseaseadvantageone.png');
  /* 背景图从上到下整个盒子展示 */
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: top center;
}

.advantage-text {
  color: #333;
  font-size: 14px;
  line-height: 1.6;
  text-align: justify;
  padding: 15px;
  margin: 0;
}



/* 服务权益说明部分 */
.service-rights-section {
  width: 100%;
  padding: 16px 0;
  position: relative;
  z-index: 1;
}

.service-rights-header {
  width: 100%;
  position: relative;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 10%;
}

.service-rights-bg-left {
  width: auto;
  height: 30px;
  display: block;
}

.service-rights-title {
  color: #FF7300;
  font-size: 24px;
  font-weight: bold;
  margin: 0 10px;
  white-space: nowrap;
  text-shadow: 0 0 10px #fff, 0 0 20px #fff, 0 0 30px #fff, 0 0 40px #fff;
}

.service-rights-bg-right {
  width: auto;
  height: 30px;
  display: block;
}

.service-list {
  width: 100%;
  padding: 0 8px;
  position: relative;
  z-index: 1;
}

.service-item {
  background-color: #fff;
  border-radius: 8px;
  margin-bottom: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.service-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 13px;
  cursor: pointer;
  background-color: #fff;
  transition: background-color 0.3s;
}

.service-item-header:active {
  background-color: #f5f5f5;
}

.service-item-title {
  flex: 1;
  color: #FE7D1E;
  font-size: 16px;
  font-weight: 500;
  margin-right: 6px;
}

.service-item-availability {
  color: #333333;
  font-size: 15px;
  margin-right: 6px;
  white-space: nowrap;
}

.arrow-icon {
  width: 16px;
  height: 16px;
  transition: transform 0.3s;
}

.service-item.expanded .arrow-icon {
  transform: rotate(180deg);
}

.service-item-content {
  padding: 0 13px 13px;
  background-color: #fff;
}

.service-item-text {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  text-align: justify;
  background-color: #FFF8F3;
  border-radius: 5px;
  padding: 10px;
}

.service-sub-item {
  margin-bottom: 15px;
}

.service-sub-item:last-child {
  margin-bottom: 0;
}

.service-sub-title {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  gap: 8px;
}

.service-sub-title-text {
  color: #FE7D1E;
  font-size: 15px;
  font-weight: bold;
  white-space: nowrap;
}

.service-sub-title-icon-left,
.service-sub-title-icon-right {
  width: auto;
  height: 20px;
  display: block;
  flex-shrink: 0;
}

.service-sub-text {
  color: #666;
  font-size: 14px;
  line-height: 1.6;
  text-align: justify;
}

/* 响应式设计 */
@media (max-width: 375px) {
  .advantage-title {
    font-size: 15px;
  }
  
  .advantage-text {
    font-size: 14px;
  }
  
  .service-rights-title {
    font-size: 23px;
  }
  
  .service-item-title {
    font-size: 16px;
  }
  

}

@media (min-width: 768px) {
  .advantage-title {
    font-size: 20px;
  }
  
  .advantage-content {
    padding: 0 16px 19px;
  }
  
  .advantage-text {
    font-size: 18px;
  }
  
  .service-item-header {
    padding: 16px;
  }
  
  .service-item-title {
    font-size: 16px;
  }
  

}

/* 下载引导图样式 */
.guide-image-overlay {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  box-sizing: border-box;
}

.guide-image-content {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.guide-image {
  display: block;
  width: 85%;
  max-width: 100%;
  height: auto;
  margin: 0 auto;
  object-fit: contain;
  position: absolute;
  top: 0px;
}

/* 固定定位的下载按钮 */
.download-btn-wrapper {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  padding: 12px 16px;
  background: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.download-btn {
  width: 100%;
  height: 44px;
  background: linear-gradient(135deg, #FF9A00 0%, #FF7300 100%);
  color: #fff;
  font-size: 16px;
  font-weight: 500;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
  outline: none;
}

.download-btn:active {
  opacity: 0.8;
  transform: scale(0.98);
}
</style>


// WEBPACK FOOTER //
// src/views/download.vue